export default __webpack_public_path__ + "static/media/banner3.5e048118.png";